<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow"> 
      <!------------------------search---------------------->
        <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <el-form-item ref="query" :model="query">
            <el-input placeholder="请输入关键字" v-model="query.key" ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
          </el-form-item>
          <el-form-item v-if="actionauth.base_account_add=='true'">
            <el-button type="primary" icon="el-icon-circle-plus-outline"  @click="addAccount">新增帐户</el-button>
          </el-form-item>
        </el-form>
      <!------------------------search end---------------------->

      <!------------------------add---------------------->
        <el-dialog title="新增帐户" :visible.sync="createDialog">
          <el-form ref="create" :model="create" :rules="rules" label-width="100px" size="medium">
            <el-col :span="14">
              <el-form-item label="帐户名称" prop="name">
                <el-input v-model="create.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item label="编号" prop="number">
                <el-input v-model="create.number"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="户名">
                <el-input v-model="create.truename"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="13">
              <el-form-item label="帐号">
                <el-input v-model="create.account"></el-input>
              </el-form-item>
            </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="createDialog = false">取 消</el-button>
            <el-button size="medium" type="primary" :loading="createLoading" @click="createSave">保 存</el-button>
          </div>
        </el-dialog>
      <!------------------------add end---------------------->
      <div class="backborder2" style="margin-top:10px">
        <el-table :data="lists" v-loading="listLoading">
            <el-table-column prop="number" label="编号" width="110" align="center"></el-table-column>
            <el-table-column prop="name" label="帐户名称"></el-table-column>
            <el-table-column prop="truename" label="户名" width="170" align="center"></el-table-column>
            <el-table-column prop="account" label="帐号" width="170" align="center"></el-table-column>
            <el-table-column label="操作" width="140" v-if="actionauth.base_account_edit=='true' || actionauth.base_account_del=='true'" align="center">
	            <template slot-scope="scope">
	                <el-button type="primary" size="small" circle icon="el-icon-edit" @click="editCurrent(scope.row)" v-if="actionauth.base_account_edit=='true'"></el-button>
	            	<el-button type="danger" size="small" circle icon="el-icon-delete" @click="delCurrent(scope.row)" v-if="actionauth.base_account_del=='true'"></el-button>
	            </template>
            </el-table-column>
        </el-table>
        <div class="block">
        <!--分页begin-->
          <el-pagination
            @size-change="pageSizeChange"
            @current-change="pageCurrentChange"
            :current-page="query.p"
            :page-sizes="[10, 20, 50]"
            :page-size="query.rollpage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total_rows">
          </el-pagination>
          <!--分页end-->
        </div>
      </div>

      <!------------------------edit---------------------->
        <el-dialog title="编辑帐户信息" :visible.sync="updateDialog">
          <el-form ref="update" :model="update" :rules="rules" label-width="100px" size="medium">
            <el-col :span="24">
              <el-col :span="14">
                <el-form-item label="帐户名称" prop="name">
                  <el-input v-model="update.name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="编号" prop="number">
                  <el-input v-model="update.number"></el-input>
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="24">
              <el-col :span="10">
                <el-form-item label="户名">
                  <el-input v-model="update.truename"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="13">
                <el-form-item label="帐号">
                  <el-input v-model="update.account"></el-input>
                </el-form-item>
              </el-col>
            </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="updateDialog = false">取 消</el-button>
            <el-button size="medium" type="primary" :loading="updateLoading" @click="updateSave">保 存</el-button>
          </div>
        </el-dialog>
      <!------------------------edit end---------------------->
  </div>
  </transition>   
</template>

<script>

export default {
  data () {
    return {
      actionauth:'', //操作功能权限
      transitionshow:true,
      url:this.GLOBAL.domain+"Account/index",
      lists:[],
      listLoading:false,
      query:{
        act:'lists',
        token:this.$cookies.get('token'),
        key:'',
        rollpage: 10, // 页大小
        p: 1
      },
      total_rows: 0,
      createDialog: false,
      createLoading: false,
      create: {
        act:'add',
        token:this.$cookies.get('token'),
        name:'',
        number:'',
        truename:'',
        account:''
      },
      updateDialog:false,
      updateLoading:false,
      update: {
        act:'edit',
        token:this.$cookies.get('token'),
        id:'',
        name:'',
        number:'',
        truename:'',
        account:''
      },
      rules: {
        name: [
            { required: true, message: '请输入银行帐户名称', trigger: 'blur' },
            { min: 2, max: 20, message: '长度在 2 到 20 个字符'}
        ],
        number: [
            { required: true, message: '请输入编号', trigger: 'blur' },
            { min: 1, max: 8, message: '长度在 1 到 8 个字符'},
            { pattern:/^[A-Za-z0-9]+$/, message: '编号只能为字母和数字'}
        ]
      }
    }
  },
  mounted(){
    this.getactionauth();
    this.getList();
  },
  methods:{
  
    /** 获取操作功能权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
  	
    //重置表单
    reset() {
        this.$refs.create.resetFields();
    },
    
    //添加账户
    addAccount() {
    	this.$emit('listenchild',{name:'添加银行账户',url:'Accountadd'});
    	//this.createDialog=true;
    },
    
    //新增
    createSave(){
      // 主动校验
      this.$refs.create.validate((valid) => {
          if (valid) {
              this.createLoading=true;
              var resource = this.$resource(this.url);
              resource.save(this.create).then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001'){
                      this.$router.push('/login')
                    }
                    this.$message.error(res.data.Message);
                    this.createLoading=false;
                  }else{
                    this.$message.success(res.data.Message);
                    this.createDialog=false;
                    this.createLoading=false;
                    this.reset();
                    this.getList();
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
                  this.createDialog=false;
                  this.createLoading=false;
              });
          }
          else {
            return false;
          }
      });
    },
    //信息列表
    getList(){
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.query(this.query).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
          this.listLoading = false;
        }else{
          this.lists = JSON.parse(Base64.decode(res.data.Data));
          this.total_rows=parseInt(res.data.count);
          this.listLoading = false;
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.listLoading=false;
      });
    },
    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },
    //编辑
    editCurrent(item){
    	this.$emit('listenchild',{name:'编辑银行账户',url:'Accountedit',data:item});
    	/**
        this.update.id=item.id
        this.update.name=item.name
        this.update.number=item.number
        this.update.truename=item.truename
        this.update.account=item.account
        this.updateDialog=true;
        */
    },
    //更新
    updateSave(){
      // 主动校验
      this.$refs.update.validate((valid) => {
          if (valid) {
              this.updateLoading=true;
              var resource = this.$resource(this.url);
              resource.save(this.update).then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001'){
                      this.$router.push('/login')
                    }
                    this.$message.error(res.data.Message);
                    this.updateLoading=false;
                  }else{
                    this.$message.success(res.data.Message);
                    this.updateDialog=false;
                    this.updateLoading=false;
                    this.getList();
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
                  this.updateDialog=false;
                  this.updateLoading=false;
              });
          }
          else {
            return false;
          }
      });
    },
    //删除
    delCurrent(item){
      this.$confirm('此操作将永久删除 ' + item.name + ', 是否继续?', '提示', { type: 'warning' })
              .then(() => {
              // 向请求服务端删除
              var resource = this.$resource(this.url);
              resource.save({ act:'del',id: item.id,token:this.$cookies.get('token')})
                  .then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001'){
                      this.$router.push('/login')
                    }
                    this.$message.error(res.data.Message);
                  }else{
                    this.$message.success('成功删除了' + item.name + '!');
                    this.getList();
                  }
              }).catch((res) => {
                      this.$message.error(this.GLOBAL.errortext);
               });
          })
          .catch(() => {
              this.$message.info('已取消操作!');
          });
    }
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/base/Account.vue